import Button from "@mui/material/Button";
import { describeFailure, isRetryable } from "../utilities/shortLinks";

/**
 * What is going on with a share link, shown right under it:
 *
 *  - while its short link is being created: a quiet "Creating short link..." line,
 *  - when no short link could be had: why, and that the full link is shown instead (with a
 *    "Try again" button when asking again can help). A share that is already over says so
 *    and what to do (new expiry date) - its full link is no more use than a short one,
 *  - otherwise nothing.
 *
 * Sharing never depends on the short-link service, so a failure is not an error dialog - but it
 * must not be silent either: a full link that looks like a short one is how this went unnoticed.
 */
export default function ShortLinkNotice({ pending = false, failure = null, onRetry }) {
  if (!pending && !failure) return null;

  const base = { fontSize: 12, lineHeight: 1.45, margin: "4px 2px 0", textAlign: "left" };

  if (pending) {
    return (
      <div role="status" style={{ ...base, color: "#52606d" }}>
        Creating short link…
      </div>
    );
  }

  return (
    <div role="status" style={{ ...base, color: "#b45309" }}>
      {describeFailure(failure)}
      {failure.kind !== "expired" && " The full link is shown instead."}
      {onRetry && isRetryable(failure) && (
        <Button
          size="small"
          onClick={onRetry}
          sx={{ textTransform: "none", fontSize: 12, minWidth: 0, padding: "0 6px", marginLeft: "4px" }}
        >
          Try again
        </Button>
      )}
    </div>
  );
}
